module.exports = __webpack_public_path__ + "static/media/ws.6d92b2e4.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ws.svg
// module id = 974
// module chunks = 0